














































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bForm from 'bootstrap-vue/es/components/form/form';
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import bFormRadio from 'bootstrap-vue/es/components/form-radio/form-radio';
import bFormRadioGroup from 'bootstrap-vue/es/components/form-radio/form-radio-group';
import bImg from 'bootstrap-vue/es/components/image/img';
import bInput from 'bootstrap-vue/es/components/form-input/form-input';
import bLink from 'bootstrap-vue/es/components/link/link';
import bRow from 'bootstrap-vue/es/components/layout/row';
import bModal from 'bootstrap-vue/es/components/modal/modal';
import vBModal from 'bootstrap-vue/es/directives/modal/modal';

import {
  Address,
  StoreAddress,
} from '@/models';

import FulfillmentSelectionForm from '@/components/checkout/FulfillmentSelectionForm.vue';
import PriceBlock from '@/components/PriceBlock.vue';
import PrimaryButton from '@/components/PrimaryButton.vue';

import CheckoutView from './CheckoutView';
import OrderSummary from './OrderSummary.vue';
import PromotionalCodesForm from './PromotionalCodesForm.vue';

@Component({
  components: {
    FulfillmentSelectionForm,
    FontAwesomeIcon,
    OrderSummary,
    PriceBlock,
    PrimaryButton,
    PromotionalCodesForm,

    bButton,
    bCol,
    bContainer,
    bForm,
    bFormGroup,
    bFormRadio,
    bFormRadioGroup,
    bImg,
    bInput,
    bLink,
    bModal,
    bRow,
  },
  directives: {
    'b-modal': vBModal,
  },
})
export default class DesktopCheckoutView extends CheckoutView {
  public readonly faCcMastercard = faCcMastercard;

  get singleShippingAddress(): StoreAddress | Address | null {
    return (
      this.order &&
      this.order.fulfillments.length === 1 &&
      this.order.fulfillments[0].shippingAddress) ?
        this.order.fulfillments[0].shippingAddress! : null;
  }

  public closeFulfillmentSelectionForm() {
    this.$root.$emit('bv::hide::modal', 'scc-fulfillment-service-modal');
  }

  public async submitFulfillment(index: number, fulfillment: { selected: string, selectedAddress?: Address }) {
   await this.setFulfillment(index, fulfillment);
   // Close modal.
   this.closeFulfillmentSelectionForm();
  }
}

